import React from "react";
import { useTranslation } from "react-i18next";
import Footer from "./Shared/Footer";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import { SlLocationPin } from "react-icons/sl";

import { feedbackIntegration } from "@sentry/react";

import * as Sentry from "@sentry/react";

import { showBugReportDialog } from "../utils/bugreport";
import Image from "./Shared/Image";
import Button from "./ui/button";

const feedback = feedbackIntegration({
  // Disable injecting the default widget
  autoInject: false,
});

const ErrorFallback = () => {
  const { t } = useTranslation();
  let loggedInState = localStorage.getItem("safetag-username") ? true : false;
  const [loggedIn, setLoggedIn] = React.useState(loggedInState);

  feedback.attachTo(document.querySelector("#your-button"), {
    formTitle: "Report a Bug!",
  });

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar setLoggedIn={setLoggedIn} loggedIn={loggedIn} />
      <div className="fixed top-0 left-0 w-full h-full bg-background z-[-1]"></div>
      <img
        src="/assets/branding/background.webp"
        className="h-screen w-screen fixed top-0 left-0 z-[-1] opacity-5 object-cover"
        alt="background"
      />

      <section className="flex-1 px-4 w-full pt-24 pb-12">
        <div className="w-full flex flex-col items-center pt-32 pb-10">
          <div className="flex flex-col w-full max-w-xl items-center p-8 border bg-white rounded-xl relative text-center gap-3">
            <Image
              src="/assets/404/dog.webp"
              className="absolute w-[400px] max-w-full object-cover bottom-full translate-y-[17%]"
            />
            <h2 className="text-center text-2xl font-semibold">
              {t("error_boundary.main.title")}
            </h2>
            <p className="text-sm">{t("error_boundary.main.desc1")}</p>
            <Button
              onClick={() => {
                localStorage.clear();
                window.location.reload();
                window.location.href = "/";
              }}
            >
              {t("error_boundary.main.button")}
            </Button>
            <button
              hidden
              id="your-button"
              onClick={() => showBugReportDialog()}
              className="py-3 -mt-7 text-pr font-semibold transition-all rounded-lg "
            >
              {t("error_boundary.main.report")}
            </button>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ErrorFallback;
